/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "gear-ac72d759--sprite",
  "use": "gear-ac72d759--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"gear-ac72d759--sprite\">\r\n  <defs>\r\n    <clipPath id=\"gear-ac72d759--sprite_clip-Settings\">\r\n      <rect width=\"36\" height=\"36\" />\r\n    </clipPath>\r\n  </defs>\r\n  <g id=\"gear-ac72d759--sprite_Settings\" clip-path=\"url(#gear-ac72d759--sprite_clip-Settings)\">\r\n    <g id=\"gear-ac72d759--sprite_Rectangle_9217\" data-name=\"Rectangle 9217\" fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\">\r\n      <rect width=\"36\" height=\"36\" stroke=\"none\" />\r\n      <rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" />\r\n    </g>\r\n    <g id=\"gear-ac72d759--sprite_Component_1\" data-name=\"Component 1\" transform=\"translate(10 10)\">\r\n      <path id=\"gear-ac72d759--sprite_Path_7107\" data-name=\"Path 7107\" d=\"M93.956,763.163h-1.15a5.944,5.944,0,0,0-.779-1.89l.809-.81a1.008,1.008,0,0,0,0-1.42l-.449-.45a1.008,1.008,0,0,0-1.42,0l-.819.82a5.467,5.467,0,0,0-1.879-.78v-1.15a.99.99,0,0,0-1-1h-.64a.99.99,0,0,0-1,1v1.15a5.855,5.855,0,0,0-1.869.78l-.819-.82a1,1,0,0,0-1.41,0l-.459.46a1.008,1.008,0,0,0,0,1.42l.819.82a5.534,5.534,0,0,0-.779,1.87h-1.16a1,1,0,0,0-1,1v.65a1,1,0,0,0,1,1h1.16a5.783,5.783,0,0,0,.779,1.86l-.819.82a1,1,0,0,0,0,1.41l.459.46a1,1,0,0,0,1.41,0l.809-.81a5.886,5.886,0,0,0,1.879.78v1.15a1,1,0,0,0,1,1h.64a1,1,0,0,0,1-1v-1.15a5.67,5.67,0,0,0,1.879-.78l.819.82a1.006,1.006,0,0,0,1.42,0l.449-.46a1,1,0,0,0,0-1.41l-.819-.82a5.64,5.64,0,0,0,.789-1.87h1.15a1,1,0,0,0,1-1v-.65A1,1,0,0,0,93.956,763.163Zm-4.877,3.44a3,3,0,0,1-5.117-2.12,3,3,0,1,1,5.117,2.12Z\" transform=\"translate(-78.955 -756.483)\" fill=\"currentColor\" />\r\n    </g>\r\n  </g>\r\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
